import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { throttle } from 'throttle-debounce';

import { useIsDesktop } from '@cian/valuation-utils-component';

import { SendReport } from '../../components/SendReport';
import { withVisibleInReportStatus } from '../../utils/report';
import { useDidMount } from './utils';
import { EReportStatus } from '../../constants/report';
import { useOpenPreview } from '../../utils/sendReport';
import { toggleStickyFooterVisible } from '../../actions/page';
import { isElementInViewport } from '../../utils/isElementInViewport';
import { selectIsStickyFooterVisible } from '../../selectors/page';
import { getReportState } from '../../selectors/report';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { VIEWED_TIMEOUT } from '../../constants/viewedBlock';
import { trackEstimationReportBannerView } from '../../utils/teaser';

const SCROLL_WATCH_HANDLER_THROTTLE_MS = 350;

export const SendReportContainer_: React.FC = () => {
  const ref = React.useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const { reportStatus } = useSelector(getReportState);
  const isStickyFooterVisible = useSelector(selectIsStickyFooterVisible);

  useDidMount();

  React.useEffect(() => {
    const handler = throttle(SCROLL_WATCH_HANDLER_THROTTLE_MS, () => {
      if (ref.current && reportStatus === EReportStatus.Default) {
        const isInViewport = isElementInViewport(ref.current, 0.1);

        if (isInViewport && isStickyFooterVisible) {
          dispatch(toggleStickyFooterVisible(false));
        }

        if (!isInViewport && !isStickyFooterVisible) {
          dispatch(toggleStickyFooterVisible(true));
        }
      }
    });

    window.addEventListener('scroll', handler);

    return () => window.removeEventListener('scroll', handler);
  }, [dispatch, isStickyFooterVisible, reportStatus]);

  const onSubmit = useOpenPreview();

  return (
    <ActionAfterViewObserver callback={trackEstimationReportBannerView} callbackDelay={VIEWED_TIMEOUT}>
      <SendReport ref={ref} isDesktop={isDesktop} onSubmit={onSubmit} />
    </ActionAfterViewObserver>
  );
};

SendReportContainer_.displayName = 'SendReportContainer';

export const SendReportContainer = withVisibleInReportStatus({ in: [EReportStatus.Default] })(SendReportContainer_);
